import React from "react";
import {
  CircleAlert,
  CircleCheck,
  Info,
  TriangleAlert,
  XIcon,
} from "lucide-react";

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "../../shadcn/components/ui/alert";
import { Button } from "../../shadcn/components/ui/button";
import { cn } from "../../shadcn/lib/utils";

const ICONS = {
  error: CircleAlert,
  warning: TriangleAlert,
  info: Info,
  success: CircleCheck,
};

// Inline message with the old MUI `severity` names (error, warning, info, success).
// DS Manager has no warning/success colours; the icon carries the tone.
const StatusAlert = ({
  severity = "info",
  title,
  action,
  onClose,
  closeLabel,
  icon = true,
  className,
  children,
  ...props
}) => {
  const Icon = ICONS[severity] || Info;
  return (
    <Alert
      variant={severity === "error" ? "destructive" : "default"}
      className={cn(
        // The action sits beside the text when the alert itself has room and
        // wraps below it otherwise (screen width alone ignores the sidebar).
        (action || onClose) && "flex flex-wrap items-center gap-x-3 gap-y-2",
        className
      )}
      {...props}
    >
      {icon ? <Icon aria-hidden="true" /> : null}
      <div className="min-w-0 flex-1 basis-60">
        {title ? (
          <AlertTitle className="font-semibold">{title}</AlertTitle>
        ) : null}
        <AlertDescription>{children}</AlertDescription>
      </div>
      {action ? (
        <div className="flex max-w-full shrink-0 flex-col items-start gap-1">
          {action}
        </div>
      ) : null}
      {onClose ? (
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={closeLabel}
          onClick={onClose}
          className="absolute top-2 right-2 md:static"
        >
          <XIcon aria-hidden="true" />
        </Button>
      ) : null}
    </Alert>
  );
};

export default StatusAlert;
